import { FC, MouseEvent } from 'react';
import { useThemeMode } from '@/hooks/useThemeMode';

const NavActions: FC = () => {
  const { toggleTheme } = useThemeMode();

  const handleOpenContact = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    // @ts-expect-error custom event dispatched for layout drawer
    window.dispatchEvent(new Event('open-contact'));
  };

  return (
    <div className="flex items-center gap-3 leading-none md:justify-end">
      <div className="hidden items-center gap-1 text-[13px] font-medium text-zinc-700 dark:text-zinc-300 md:flex">
        <span className="tracking-wide">TRBO</span>
        <span className="text-zinc-500 dark:text-zinc-500">·</span>
        <span className="text-zinc-900 dark:text-zinc-100">$0.00334</span>
        <span className="text-[12px] font-medium text-green-500">+0.33%</span>
      </div>
      <a
        href="/contact"
        onClick={handleOpenContact}
        className="rounded-full bg-brand-folly px-3.5 py-1.5 text-sm font-medium text-white transition-colors hover:bg-[#e02756]"
      >
        Contact Us
      </a>
      <button
        onClick={toggleTheme}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-zinc-100/80 transition-colors hover:bg-zinc-200 dark:bg-zinc-800/60 dark:hover:bg-zinc-700"
        aria-label="Toggle theme"
        type="button"
      >
        <svg className="h-5 w-5 text-zinc-600 dark:text-zinc-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      </button>
    </div>
  );
};

export default NavActions;
